/**
 * Data a page asks for first, started while the sign-in check (/api/auth/me) still holds
 * it in ProtectedRoute, so the two waits overlap instead of following each other
 * (2026-10-14). Only the candidate profile so far: its request is the slow one on a
 * reload or a new tab, and every profile tab starts with it.
 */
import { prefetchProfile } from '../store/actions/profileActions';

const PROFILE_PATH = /^\/talent\/profile\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/|$)/i;

export function prefetchForPath(pathname: string, dispatch: (action: any) => unknown): void {
  const profile = PROFILE_PATH.exec(pathname);
  if (profile) dispatch(prefetchProfile(profile[1]));
}
